import type { ChunkRef } from '@frontend/viewer-core';

import type { DrawingModel } from './types';

/**
 * True when a chain is exactly one whole stitched loop.
 *
 * Lets loop-granularity picking keep returning a single `loop` ref in the case
 * that dominates every unmapped drawing and most mapped ones, instead of
 * expanding into chunks the moment chaining exists. Worth the check: a `loop`
 * ref is what `summarizeSelection` reads area and a count of one from.
 */
export const coversWholeLoop = (
  model: DrawingModel,
  chain: readonly ChunkRef[],
): boolean => {
  const [first] = chain;
  if (!first) {
    return false;
  }
  const loop = model.loopsById.get(first.loopId);
  return (
    loop !== undefined &&
    chain.length === loop.chunks.length &&
    chain.every(({ loopId }) => loopId === first.loopId)
  );
};
